<script setup>
import { inject } from 'vue'
import app from '@/main.js'
import InlineSvg from 'vue-inline-svg'
import CreatorGiftsModalItem from '@/components/CreatorGifts/Include/CreatorGiftsModal/CreatorGiftsModalItem.vue'
import { UAParser } from 'ua-parser-js'

defineProps({
  items: {
    type: Array,
    default: () => [],
    required: true
  },
  creator: {
    type: Object,
    default: () => ({
      userId: null
    }),
    required: true
  }
})

const close = inject('close')
const { device } = UAParser()
</script>

<template>
  <div
    ref="el"
    :class="[device.is('mobile') ? 'rounded-t-xl self-end' : 'rounded-xl self-center']"
    class="bg-white p-4 shadow-lg w-full relative max-h-[96%] overflow-y-auto thin-scrollbar"
    @click.stop>
    <div class="mb-6 flex items-center gap-2 gap-y-5 justify-between">
      <h3 class="text-2xl">
        {{ creator.name }}'s {{ app.$i18n.t('gifts.digital') }}
      </h3>

      <button
        class="text-gray-950 p-2 -mr-2"
        type="button"
        @click="close">
        <InlineSvg
          :src="require('@/assets/svg/design/cross.svg')"
          class="w-3 h-3"/>
      </button>
    </div>

    <div class="grid grid-cols-3 xs:grid-cols-4 gap-4">
      <CreatorGiftsModalItem
        v-for="item in items"
        :key="item.id"
        :item="item"/>
    </div>
  </div>
</template>